import { ReactNode } from 'react';
import { createComponent, createHook } from 'reakit-system';
import { BoxHTMLProps } from '../Box/Box';
import { useIsland } from '../Island/Island';
import { ProgressBar, ProgressBarProps } from '../ProgressBar/ProgressBar';
import { Stack } from '../Stack/Stack';

export type FormStepOptions = {
  stepValue: ProgressBarProps['value'];
  headerContent?: ReactNode;
  footerContent?: ReactNode;
};

const useFormStep = createHook<FormStepOptions, BoxHTMLProps>({
  keys: ['stepValue', 'headerContent', 'footerContent'],
  compose: [useIsland],
  useOptions(options) {
    return {
      size: 'size-1',
      ...options,
    };
  },
  useProps(options, props) {
    return {
      ...props,
      children: (
        <Stack space="sp-24">
          <Stack space="sp-16">
            {options.headerContent}
            <ProgressBar value={options.stepValue} />
          </Stack>
          {props.children}
          {options.footerContent}
        </Stack>
      ),
    };
  },
});

export const FormStep = createComponent({
  as: 'div',
  useHook: useFormStep,
});
